// JaMobile — obrazovka JA pre robotníka (mview_appka_v1, 17. 10. 2026; schválený mockup Kronika 1508/1513).
// Meno, partia/rola, jazyk (ide sám z karty, ústava 121.8 — žiadny prepínač), čo čaká v telefóne na odoslanie,
// tento týždeň z dochádzky (GET /api/dochadzka/?employee_id=&od=&do=), Odhlásiť.
import React, { useEffect, useState } from 'react'
import { M } from './mockupTheme.js'   // mview_appka_v2: vzhľad = mockup v5 (Mirko 18. 10., Kronika 1585)
import { fetchAuth } from '../auth/fetchAuth.js'
import { useT } from '../i18n.js'
import { doAll } from '../offline/dochadzkaOffline.js'
import { obAll } from '../offline/diaryOffline.js'

const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10)
const JAZYK = { sk: 'Slovenčina', uk: 'Українська', pl: 'Polski', sq: 'Shqip', en: 'English', ru: 'Русский', cs: 'Čeština' }
const DNI = ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So']

export default function JaMobile({ user, me, onLogout, dalsie, onOtvor, naDesktop }) {   // STAVBA_HISTORIA_V1: dalsie = časti Matrixu mimo lišty
  const t = useT()
  const [tyzden, setTyzden] = useState(null)
  const [fronta, setFronta] = useState(0)
  const emp = (me && me.employee_id) || (user && user.employee_id) || ''

  useEffect(() => {
    ;(async () => {
      const a = await doAll(); let b = []; try { b = await obAll() } catch (_) {}
      setFronta((a || []).length + (b || []).length)
    })()
    if (!emp) { setTyzden([]); return }
    const dnes = new Date(); const po = new Date(dnes); po.setDate(dnes.getDate() - ((dnes.getDay() + 6) % 7))
    fetchAuth('/api/dochadzka/?employee_id=' + encodeURIComponent(emp) + '&od=' + iso(po) + '&do=' + iso(dnes))
      .then(r => r.ok ? r.json() : []).then(rows => {
        const m = new Map()
        ;(Array.isArray(rows) ? rows : []).forEach(r => {
          const k = String((r && r.date) || ''); if (!/^\d{4}-\d{2}-\d{2}$/.test(k)) return   // riadok bez dátumu sa preskočí, obrazovka nespadne
          const x = m.get(k) || { h: 0, z: new Set() }
          x.h += Number(r.hodiny_platne != null ? r.hodiny_platne : r.hodiny) || 0; if (r.project_name) x.z.add(r.project_name.replace(/^[^·]*·\s*/, ''))
          m.set(k, x)
        })
        setTyzden([...m.entries()].sort((a, b) => a[0].localeCompare(b[0])))
      }).catch(() => setTyzden([]))
  }, [emp])

  const karta = { background: M.card, border: `1px solid ${M.line}`, borderRadius: 16, padding: 16, marginBottom: 16 }
  const riadok = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: `1px solid ${M.field}`, fontSize: 16, gap: 10 }
  const l = { color: M.mut, fontSize: 14 }
  const lang = String((user && user.language_code) || 'sk').toLowerCase()

  return (
    <div style={{ padding: 16, paddingBottom: 24, background: M.bg, minHeight: '100%', fontFamily: M.font, color: M.txt }}>
      <div style={{ fontSize: 26, fontWeight: 800, margin: '4px 0 12px' }}>{t('mobile.tab.ja')}</div>
      <div style={karta}>
        <div style={riadok}><span style={l}>{t('mobile.ja.meno')}</span><b>{(user && (user.cele_meno || user.display_name || user.username)) || ''}</b></div>
        <div style={riadok}><span style={l}>{t('mobile.ja.jazyk')}</span><b>{(JAZYK[lang] || lang) + ' · ' + t('mobile.ja.z_karty')}</b></div>
        <div style={{ ...riadok, borderBottom: 'none' }}><span style={l}>{t('mobile.ja.fronta')}</span><b style={{ color: fronta ? M.amb : M.txt }}>{fronta}</b></div>
      </div>
      <div style={karta}>
        <div style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 700, color: M.mut, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{t('mobile.ja.tyzden')}</div>
        {tyzden === null && <div style={l}>{t('common.loading')}</div>}
        {tyzden && !tyzden.length && <div style={l}>{t('mobile.ja.tyzden_prazdny')}</div>}
        {(tyzden || []).map(([d, x], i) => (
          <div key={d} style={{ ...riadok, borderBottom: i === tyzden.length - 1 ? 'none' : riadok.borderBottom }}>
            <span>{DNI[new Date(d + 'T12:00:00').getDay()]} {Number(d.slice(8, 10))}. {Number(d.slice(5, 7))}.</span>
            <b style={{ textAlign: 'right' }}>{(Math.round(x.h * 100) / 100).toFixed(2).replace('.', ',')} h{x.z.size ? ' · ' + [...x.z].join(', ') : ''}</b>
          </div>
        ))}
      </div>
      {/* STAVBA_HISTORIA_V1 (Mirko 21. 10. 2026, ksbx-appky 2677/2690): lišta je podľa role — časti, ktoré rola mala v mview doteraz, sú tu; nič nezmizlo */}
      {dalsie && dalsie.length > 0 && <div style={karta}>
        <div style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 700, color: M.mut, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Ďalšie časti Matrixu</div>
        {dalsie.map((x, i) => <div key={x.id} role="button" onClick={() => onOtvor && onOtvor(x.id)} style={{ ...riadok, cursor: 'pointer', borderBottom: i === dalsie.length - 1 ? 'none' : riadok.borderBottom }}><span>{x.nazov}</span><span style={{ color: M.mut, fontSize: 20 }}>›</span></div>)}
      </div>}
      {naDesktop && <button type="button" onClick={() => { try { localStorage.setItem('kamir_v2_view', 'desktop') } catch (_) {} window.location.reload() }} style={{ width: '100%', minHeight: 52, border: `1px solid ${M.line}`, borderRadius: 16, background: M.card, color: M.ac, fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginBottom: 12 }}>Prejsť na desktop</button>}
      <button type="button" onClick={onLogout} style={{ width: '100%', minHeight: 52, border: `1px solid ${M.line}`, borderRadius: 16, background: M.field, color: M.txt, fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>{t('mobile.logout')}</button>
    </div>
  )
}
